import React, { Component } from 'react';
import withAuth from '../auth_components/js/withAuth';
import Navbar from '../Components/Navbar';
import AdminITEP from '../Components/AdminITEP/AdminITEP';


class ITEPNewContainer extends Component {
    constructor(props) {
        super(props);
        let user = JSON.parse(localStorage.getItem('user')).user;

        this.state = {
            apikey: user.apikey,
            username: user.email,
            role: user.role
        }
    }
    render() {
        return (
            <div>
                <Navbar history={this.props.history} />
                <div className="main-body">

                    <AdminITEP apikey={this.state.apikey} username={this.state.username} role={this.state.role} />

                </div>
            </div>
        )
    }
}

export default withAuth(ITEPNewContainer);


// WEBPACK FOOTER //
// ./src/Containers/ITEPNewContainer.js